import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { Router } from "@angular/router";
import { ExportService } from '../../services/export.service';
import { AuthenService } from '../../services/Authen/authen.service';
import { CoopServiceService } from '../../services/Coop/coop-service.service';
import { FamerServiceService } from '../../services/Fammer/famer-service.service';
import { ViewerService } from '../../services/Viewer/viewer.service';
import { NgxSpinnerService } from "ngx-spinner";
import { registerLocaleData } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import he from '@angular/common/locales/he';
import * as XLSX from 'xlsx';
declare var jQuery: any;
declare var google: any;
declare var $: any;

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";

import { callable, session_year } from "src/app/components/callable";

@Component({
  selector: 'app-home-agri',
  templateUrl: './home-agri.component.html',
  styleUrls: ['./home-agri.component.scss']
})
export class HomeAgriComponent implements OnInit {

  private chart_rubber: am4charts.XYChart;

  constructor(
    @Inject(PLATFORM_ID) private platformId, private zone: NgZone,

    private router: Router,
    private ExportService: ExportService,
    private AuthenService: AuthenService,
    private CoopServiceService: CoopServiceService,
    private FamerServiceService: FamerServiceService,
    private SpinnerService: NgxSpinnerService,
    private ViewerService: ViewerService
  ) {
  }

  @ViewChild('TABLE', { static: false }) TABLE: ElementRef; //
  @ViewChild('Coop_regions') Coop_regions: ElementRef; //
  @ViewChild('MapMember') MapMember: ElementRef; //

  data_Old: any = [];
  data_Regis: any = [];
  totalProduc: any = [];
  datayear: any;
  standard: any;
  year_now: any;
  provinceName: any;
  countryName: any;
  StatusSumYearAll: any;
  MemberYearDataSum: any = 0;
  Committee: any;
  CommitteeYear: any = 0;
  CommitteeYearM: any = 0;
  CommitteeYearFM: any = 0;
  dataarrayOld: any = [];
  ageTypeDetail: any = [];
  dataRegister: any;
  dataQuit: any;
  year_last: any;
  index_id: any;
  AssetUseItemYear: any;
  RegisterQiutYear: any;
  EndmonthYear: any;
  StatusProvinceYearOne: any;
  StatusProvinceYearOne_chart: any;
  bkk: number;
  DataType_Coop: any = '1';
  DataType_Agri: any = '2';
  RubberProduct: any;
  RubberSell_: any;
  coop: any;
  AGRI: any;
  AgriStatusProvinceYearOne: any;
  StatusProvinceYearOne_Agri: any;
  AgriMemberYearDataSum: any;
  AgriCommitteeYear: any;
  CommitteeYearM_Agri: any = 0;
  CommitteeYearFM_Agri: any = 0;
  Committee_Agri: any = 0;
  CommitteeYear_Agri: any;
  AgriStatusSumYearAll: any;
  AgriAssetUseItemYear: any;
  data_Old_Agri: any;
  data_Regis_Agri: any;
  dataQuit_Agri: any;
  dataRegister_Agri: any;
  AgriRegisterQiutYears: any;
  AgriEndmonthYear: any;
  RubberProduct_Agri: any;
  RubberSell_Agri_Dataset: any;
  AgriStandardYear: any;
  test: any;
  coop_: any;
  memberCoop_: any;
  committeeCoop_: any;
  DataSetMember: any;
  MemberProvinceYears: any;
  CoopCommitteeProvinceYear_Chart: any;
  CoopCommitteeProvinceYear: any;
  AGRI_: any;
  memberAGRI_: any;
  committeeAGRI_: any;
  AgriCommitteeProvinceYear_Dataset: any;
  BusinessYear1: any;
  sumstandard: any;
  sumstandard_Agri: any;
  persent_standard_not: any;
  persent_standard_pass: any;
  persent_standard_not_Agri: any;
  persent_standard_pass_Agri: any;
  sumstatus: any;
  persent_status_active: any;
  persent_status_nonActive: any;
  persent_status_active_Agri: any;
  persent_status_nonActive_Agri: any;
  orgid: any;
  SumStatus: any[] = [];
  xValues: any;
  minValues: any;
  maxXObject: any;
  minXObject: any;
  data_am: any[] = [];
  TypeAgri: any;
  TypeCoop: any;
  CoopBusinessMap_Chart: any[];
  aver_Regis: any;
  aver_Regis_Agri: any;
  year_now_: any
  Date_now: any
  Date_after_day: any
  Month_now: any
  datayear_Lst: any
  Month_now_: any
  asset: any
  machine: any
  product: any
  business: any
  OrgOrgId = "null"
  PhakId = "null"
  KhetId = "null"
  MemberYearDataFm: any = 0
  MemberYearDataM: any = 0
  CoopOracleCount: any
  CoopOracleCountactive: any
  CoopOracleCountnonActive: any
  CoopOracleTypes: any
  typeName: any
  Active_coopType1: any = 0
  InActive_coopType1: any = 0
  CoopOfficerYearMember: any = 0;
  CoopOfficerYearMemberM: any = 0;
  CoopOfficerYearMemberFm: any = 0;
  sumstandard_pass: any;
  sumstandard_notPass: any;
  CoopTypeLevelCount: any;
  TypeLevelSum1: any = 0;
  TypeLevelSum2: any = 0;
  TypeLevelSum3: any = 0;
  TypeLevelSum4: any = 0;
  TypeLevel1_type1: any;
  TypeLevel1_type2: any;
  TypeLevel1_type3: any;
  TypeLevel1_type4: any;
  TypeLevel1_type5: any;
  TypeLevel1_type6: any;
  TypeLevel1_type7: any;

  TypeLevel2_type1: any;
  TypeLevel2_type2: any;
  TypeLevel2_type3: any;
  TypeLevel2_type4: any;
  TypeLevel2_type5: any;
  TypeLevel2_type6: any;
  TypeLevel2_type7: any;

  TypeLevel3_type1: any;
  TypeLevel3_type2: any;
  TypeLevel3_type3: any;
  TypeLevel3_type4: any;
  TypeLevel3_type5: any;
  TypeLevel3_type6: any;
  TypeLevel3_type7: any;

  TypeLevel4_type1: any;
  TypeLevel4_type2: any;
  TypeLevel4_type3: any;
  TypeLevel4_type4: any;
  TypeLevel4_type5: any;
  TypeLevel4_type6: any;
  TypeLevel4_type7: any;

  StandardTypeSum_pass: any = 0
  StandardTypeSum_notPass: any = 0

  StandardType_pass_level1: any
  StandardType_notPass_level1: any

  StandardType_pass_level2: any
  StandardType_notPass_level2: any

  StandardType_pass_level3: any
  StandardType_notPass_level3: any

  StandardType_pass_level4: any
  StandardType_notPass_level4: any

  StandardType_pass_level5: any
  StandardType_notPass_level5: any

  StandardType_pass_level6: any
  StandardType_notPass_level6: any

  StandardType_pass_level7: any
  StandardType_notPass_level7: any

  net_asset_sum: any = 0
  valSum1: any = 0
  valSum2: any = 0
  valSum3: any = 0
  valSum4: any = 0
  valSum5: any = 0
  viewer: any;
  shortComingsCoop_: any;
  shortComingsCoop_Chart: any;

  ViewOAE_1: any;
  ViewOAE_2: any;
  ViewOAE_3: any;
  ViewOAE_1_detail: any;
  ViewOAE_2_detail: any;
  ViewOAE_3_detail: any;
  rubber_sum: any;

  //Variable of Check auth.
  auth_data: any;
  shortComings_verify = false;
  coop_verify = false;
  balance_sheet_verify = false;

  yearData = callable.checkYearNow();
  isViwer = false;
  listYear = callable.listYear();
  listsector = callable.getMasterSector();
  sector_now = callable.getCurrentSector();


  ngOnInit(): void {
    this.SpinnerService.show();
    // this.verify_role();

    this.get_auth_verify();
    this.year_now = ((new Date()).getFullYear() - 1) + 543;
    this.year_now_ = ((new Date()).getFullYear()) + 543;
    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;
    this.GetAgriSumMemberNewYearDataSum();
    this.GetAgriSumCommitteeNewYear();
    this.GetAgriOracleCountNEW();
    this.GetAgriOracleTypesNew();
    this.GetAgriSumOfficer();
    // this.GetCoopTypeLevelCount(); //ไม่มีความเข้มแข็ง
    // this.GetViewOAEByGroup();
    // this.GetViewRubberSumProvinceTotal();
    this.coop = true;
    this.coop_ = true;
    this.AGRI_ = true;
    this.TypeCoop = true;
    this.asset = true;
    this.get_viewer();

    registerLocaleData(he);

    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }
  }

  async selectNewYearAndSector(year, sector) {
    if (year) {
      this.year_now = callable.getCurrentYear(year);
    }

    if (sector) {
      this.sector_now = callable.getCurrentSector(sector);
    }

    this.yearData = callable.checkYearNow();

    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;
    this.GetAgriSumMemberNewYearDataSum();
    this.GetAgriSumCommitteeNewYear();
    this.GetAgriOracleCountNEW();
    this.GetAgriOracleTypesNew();
    this.GetAgriSumOfficer();
    this.coop = true;
    this.coop_ = true;
    this.AGRI_ = true;
    this.TypeCoop = true;
    this.asset = true;
    this.get_viewer();

    registerLocaleData(he);
    this.ngAfterViewInit();
    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }

    await this.timeout(1000);
    this.SpinnerService.hide();
    // sessionStorage.removeItem(session_year);
  }

  verify_role() {
    let user = JSON.parse(localStorage.getItem("access_token"));
    if (user && user['role'] == 'Admin') {
      this.router.navigate(["/user-management"]);
    }
  }

  get_date_now_and_after() {
    let Date_today = new Date();
    this.Date_after_day = new Date(Date_today);
    this.Date_after_day.setDate(this.Date_after_day.getDate() - 1);
    this.Month_now = this.Date_after_day.getMonth() + 1;
    this.Date_now = Date_today.getDate()
    this.Date_after_day = this.Date_after_day.getDate()
  }

  get_viewer() {
    let count;
    this.ViewerService.Get_viewerAll('Home').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe();
      }
    );
  }

  get_auth_verify() {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    if (this.auth_data != null) {
      this.AuthenService.Get_manage_role(this.auth_data['role']).subscribe(
        responce => {
          if (this.auth_data['role'] == 'Admin') {
            this.shortComings_verify = true;
            this.coop_verify = true;
            this.balance_sheet_verify = true;
          } else {
            for (let i = 0; i < responce.length; i++) {
              if (responce[i]['menu'] == 'ข้อบกพร่อง' && responce[i]['status'] == 'y') {
                this.shortComings_verify = true;
              }
              if ((responce[i]['menu'] == 'จำนวนสหกรณ์' && responce[i]['status'] == 'y')) {
                this.coop_verify = true;
              }
              if (responce[i]['menu'] == 'งบดุล' && responce[i]['status'] == 'y') {
                this.balance_sheet_verify = true;
              }
            }
          }
        }
      );
    }
  }

  GetViewOAEByGroup() {
    this.CoopServiceService.GetViewOAEByGroup(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
      response => {
        for (let i = 0; i < response.length; i++) {
          response[i]['total_count'] = response[i]['total_count'].toLocaleString();
          response[i]['total_rai'] = response[i]['total_rai'].toLocaleString();
          if (response[i]['groupCode'] == "1") {
            this.ViewOAE_1 = response[i];
          } else if (response[i]['groupCode'] == "2") {
            this.ViewOAE_2 = response[i];
          } else {
            this.ViewOAE_3 = response[i];
          }
        }
      }
    );
  }

  GetViewOAEDetailByGroup(groupCode) {
    let get = true;
    if (groupCode == 1) {
      if (!this.ViewOAE_1_detail) {
        get = false;
      }
    } else if (groupCode == 2) {
      if (!this.ViewOAE_2_detail) {
        get = false;
      }
    } else {
      if (!this.ViewOAE_3_detail) {
        get = false;
      }
    }

    if (get == false) {
      this.SpinnerService.show();
      this.CoopServiceService.GetViewOAEDetailByGroup(this.OrgOrgId, this.PhakId, this.KhetId, groupCode).subscribe(
        response => {
          for (let i = 0; i < response.length; i++) {
            response[i]['total_count'] = response[i]['total_count'].toLocaleString();
            response[i]['total_rai'] = response[i]['total_rai'].toLocaleString();
          }

          if (groupCode == 1) {
            this.ViewOAE_1_detail = response;
          } else if (groupCode == 2) {
            this.ViewOAE_2_detail = response;
          } else {
            this.ViewOAE_3_detail = response;
          }
          this.SpinnerService.hide();
        }
      );
    }
  }

  GetViewRubberSumProvinceTotal() {
    this.CoopServiceService.GetViewRubberSumProvinceTotal(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
      response => {
        response[0]['total_count'] = response[0]['total_count'].toLocaleString();
        response[0]['total_rai'] = response[0]['total_rai'].toLocaleString();
        this.rubber_sum = response[0];

      }
    );
  }

  CoopNav(data) {
    this.coop_ = data;
    if (this.coop_ == "coop_") {
      this.coop_ = true;
      this.memberCoop_ = false;
      this.committeeCoop_ = false;
      this.shortComingsCoop_ = false;
    }

    this.map1();
  }

  memberCoopNav(data) {
    this.memberCoop_ = data;
    if (this.memberCoop_ == "memberCoop_") {
      this.memberCoop_ = true;
      this.coop_ = false;
      this.committeeCoop_ = false;
      this.shortComingsCoop_ = false;
    }

    this.map2();
    // this.ngAfterViewInit();
  }

  committeeCoopNav(data) {
    this.committeeCoop_ = data;
    if (this.committeeCoop_ == "committeeCoop_") {
      this.coop_ = false;
      this.memberCoop_ = false;
      this.committeeCoop_ = true;
      this.shortComingsCoop_ = false;
    }

    this.map3();


  }

  shortComingsCoopNav(data) {
    this.shortComingsCoop_ = data;
    if (this.shortComingsCoop_ == "shortComingsCoop_") {
      this.coop_ = false;
      this.memberCoop_ = false;
      this.committeeCoop_ = false;
      this.shortComingsCoop_ = true;
    }

    this.map4();
  }

  GetAgriOracleCountNEW() {
    this.FamerServiceService.GetAgriOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      for (let i = 0; i < res.length; i++) {
        this.CoopOracleCount = res[i].coopCount;
        this.CoopOracleCountactive = res[i].active;
        this.CoopOracleCountnonActive = res[i].nonActive;
      }
    })
  }

  asset1() {
    this.FamerServiceService.GetAgriFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type1", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type2", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;
      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type3", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type4", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type5", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_asset_type6", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์7
      // this.zone.runOutsideAngular(() => {
      //   let chart = am4core.create("chartdiv_asset_type7", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net = "หน่วย : ล้านบาท"
      //   // Add data
      //   for (let i = 0; i < res.length; i++) {
      //     if (res[i].coop_type == "7") {
      //       data.push({
      //         "year": res[i].year,
      //         "value": res[i].net_asset
      //       })

      //     }
      //   }

      //   chart.logo.disabled = true;

      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   /* Create axes */
      //   let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      //   categoryAxis.dataFields.category = "year";
      //   categoryAxis.renderer.grid.template.location = 0;
      //   categoryAxis.renderer.minGridDistance = 30;
      //   categoryAxis.renderer.labels.template.horizontalCenter = "right";
      //   categoryAxis.renderer.labels.template.verticalCenter = "middle";
      //   categoryAxis.renderer.labels.template.rotation = 270;
      //   categoryAxis.tooltip.disabled = true;
      //   categoryAxis.fontSize = "11px"
      //   // //categoryAxis.title.text = "ปีชุดข้อมูล"

      //   /* Create value axis */
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = net
      //   valueAxis.fontSize = "11px"
      //   valueAxis.min = 0;

      //   /* Create series */
      //   let columnSeries = chart.series.push(new am4charts.ColumnSeries());
      //   columnSeries.name = "สินทรัพย์";
      //   columnSeries.dataFields.valueY = "value";
      //   columnSeries.dataFields.categoryX = "year";

      //   columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
      //   columnSeries.columns.template.propertyFields.stroke = "stroke";
      //   columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
      //   columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
      //   columnSeries.tooltip.label.textAlign = "middle";

      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.name = "value";
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.categoryX = "year";

      //   lineSeries.stroke = am4core.color("#fdd400");
      //   lineSeries.strokeWidth = 3;
      //   lineSeries.propertyFields.strokeDasharray = "lineDash";
      //   lineSeries.tooltip.label.textAlign = "middle";

      //   let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
      //   bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   bullet.dy = -10;
      //   bullet.label.text = '{valueY}'
      //   bullet.label.fill = am4core.color('#EA4755')

      //   chart.data = data;

      // })
    })

  }

  asset2() {
    this.FamerServiceService.GetAgriFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //หนี้สินของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type1", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {

            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type2", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type3", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type4", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type5", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;


        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type6", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์7
      // this.zone.runOutsideAngular(() => {
      //   let chart = am4core.create("chartdiv_debt_type7", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net = "หน่วย : ล้านบาท"
      //   // Add data
      //   for (let i = 0; i < res.length; i++) {
      //     if (res[i].coop_type == "7") {
      //       data.push({
      //         "year": res[i].year,
      //         "value": res[i].liabilities
      //       })

      //     }
      //   }

      //   chart.logo.disabled = true;

      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   /* Create axes */
      //   let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      //   categoryAxis.dataFields.category = "year";
      //   categoryAxis.renderer.grid.template.location = 0;
      //   categoryAxis.renderer.minGridDistance = 30;
      //   categoryAxis.renderer.labels.template.horizontalCenter = "right";
      //   categoryAxis.renderer.labels.template.verticalCenter = "middle";
      //   categoryAxis.renderer.labels.template.rotation = 270;
      //   categoryAxis.tooltip.disabled = true;
      //   categoryAxis.fontSize = "11px"
      //   // //categoryAxis.title.text = "ปีชุดข้อมูล"

      //   /* Create value axis */
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = net
      //   valueAxis.fontSize = "11px"
      //   valueAxis.min = 0;

      //   /* Create series */
      //   let columnSeries = chart.series.push(new am4charts.ColumnSeries());
      //   columnSeries.name = "สินทรัพย์";
      //   columnSeries.dataFields.valueY = "value";
      //   columnSeries.dataFields.categoryX = "year";

      //   columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
      //   columnSeries.columns.template.propertyFields.stroke = "stroke";
      //   columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
      //   columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
      //   columnSeries.tooltip.label.textAlign = "middle";

      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.name = "value";
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.categoryX = "year";

      //   lineSeries.stroke = am4core.color("#fdd400");
      //   lineSeries.strokeWidth = 3;
      //   lineSeries.propertyFields.strokeDasharray = "lineDash";
      //   lineSeries.tooltip.label.textAlign = "middle";

      //   let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
      //   bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   bullet.dy = -10;
      //   bullet.label.text = '{valueY}'
      //   bullet.label.fill = am4core.color('#EA4755')

      //   chart.data = data;

      // })
    })

  }

  asset3() {
    this.FamerServiceService.GetAgriFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //ทุนของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type1", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type2", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type3", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type4", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type5", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type6", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์7
      // this.zone.runOutsideAngular(() => {
      //   let chart = am4core.create("chartdiv_Capital_type7", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net = "หน่วย : ล้านบาท"
      //   // Add data
      //   for (let i = 0; i < res.length; i++) {
      //     if (res[i].coop_type == "7") {
      //       data.push({
      //         "year": res[i].year,
      //         "value": res[i].coop_capital
      //       })

      //     }
      //   }

      //   chart.logo.disabled = true;

      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   /* Create axes */
      //   let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      //   categoryAxis.dataFields.category = "year";
      //   categoryAxis.renderer.grid.template.location = 0;
      //   categoryAxis.renderer.minGridDistance = 30;
      //   categoryAxis.renderer.labels.template.horizontalCenter = "right";
      //   categoryAxis.renderer.labels.template.verticalCenter = "middle";
      //   categoryAxis.renderer.labels.template.rotation = 270;
      //   categoryAxis.tooltip.disabled = true;
      //   categoryAxis.fontSize = "11px"
      //   // //categoryAxis.title.text = "ปีชุดข้อมูล"

      //   /* Create value axis */
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = net
      //   valueAxis.fontSize = "11px"
      //   valueAxis.min = 0;
      //   /* Create series */
      //   let columnSeries = chart.series.push(new am4charts.ColumnSeries());
      //   columnSeries.name = "สินทรัพย์";
      //   columnSeries.dataFields.valueY = "value";
      //   columnSeries.dataFields.categoryX = "year";

      //   columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
      //   columnSeries.columns.template.propertyFields.stroke = "stroke";
      //   columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
      //   columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
      //   columnSeries.tooltip.label.textAlign = "middle";

      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.name = "value";
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.categoryX = "year";

      //   lineSeries.stroke = am4core.color("#fdd400");
      //   lineSeries.strokeWidth = 3;
      //   lineSeries.propertyFields.strokeDasharray = "lineDash";
      //   lineSeries.tooltip.label.textAlign = "middle";

      //   let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
      //   bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   bullet.dy = -10;
      //   bullet.label.text = '{valueY}'
      //   bullet.label.fill = am4core.color('#EA4755')

      //   chart.data = data;

      // })
    })

  }

  asset4() {
    this.FamerServiceService.GetAgriFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //กำไรของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type1", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type2", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type3", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type4", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type5", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type6", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)กลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์7
      // this.zone.runOutsideAngular(() => {
      //   let chart = am4core.create("chartdiv_profit_type7", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();

      //   let data = [];
      //   let net = "หน่วย : ล้านบาท"
      //   // Add data
      //   for (let i = 0; i < res.length; i++) {
      //     if (res[i].coop_type == "7") {
      //       data.push({
      //         "year": res[i].year,
      //         "value": res[i].net_profit
      //       })

      //     }
      //   }

      //   chart.logo.disabled = true;

      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   /* Create axes */
      //   let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      //   categoryAxis.dataFields.category = "year";
      //   categoryAxis.renderer.grid.template.location = 0;
      //   categoryAxis.renderer.minGridDistance = 30;
      //   categoryAxis.renderer.labels.template.horizontalCenter = "right";
      //   categoryAxis.renderer.labels.template.verticalCenter = "middle";
      //   categoryAxis.renderer.labels.template.rotation = 270;
      //   categoryAxis.tooltip.disabled = true;
      //   categoryAxis.fontSize = "11px"
      //   // //categoryAxis.title.text = "ปีชุดข้อมูล"

      //   /* Create value axis */
      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = net
      //   valueAxis.fontSize = "11px"
      //   valueAxis.min = 0;
      //   /* Create series */
      //   let columnSeries = chart.series.push(new am4charts.ColumnSeries());
      //   columnSeries.name = "สินทรัพย์";
      //   columnSeries.dataFields.valueY = "value";
      //   columnSeries.dataFields.categoryX = "year";

      //   columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
      //   columnSeries.columns.template.propertyFields.stroke = "stroke";
      //   columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
      //   columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
      //   columnSeries.tooltip.label.textAlign = "middle";

      //   let lineSeries = chart.series.push(new am4charts.LineSeries());
      //   lineSeries.name = "value";
      //   lineSeries.dataFields.valueY = "value";
      //   lineSeries.dataFields.categoryX = "year";

      //   lineSeries.stroke = am4core.color("#fdd400");
      //   lineSeries.strokeWidth = 3;
      //   lineSeries.propertyFields.strokeDasharray = "lineDash";
      //   lineSeries.tooltip.label.textAlign = "middle";

      //   let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
      //   bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
      //   bullet.dy = -10;
      //   bullet.label.text = '{valueY}'
      //   bullet.label.fill = am4core.color('#EA4755')

      //   chart.data = data;

      // })
    })

  }

  myModal() {
    this.FamerServiceService.GetAgriBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // เก่า model
      // ปริมารธุรกิจ รับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_deposit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].deposit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ ให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_lend", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].credit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ จัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_products", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sale_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ รวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_produce", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].collect_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"


        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ แปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_Processing", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].transfrom_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ บรืการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_service", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"

        for (let i = 0; i < res.length; i++) {
          if (res[i].service_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

  }

  Type1() {
    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ เกษตร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_business_type1_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type2() {
    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ประมง ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ ประมง ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทบริการ
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type3() {
    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ นิคม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทบริการ
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type4() {
    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ออม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type5() {
    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ร้านค้า ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้าน้คา ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type6() {
    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ บริการ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  // Type7() {
  //   this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
  //     // ปริมาณธุรกิจ เครดิต ประเภทรับฝากเงิน
  //     this.zone.runOutsideAngular(() => {
  //       am4core.useTheme(am4themes_animated);
  //       let chart = am4core.create("chartdiv_business_type7_deposit_val", am4charts.XYChart);

  //       chart.scrollbarX = new am4core.Scrollbar();
  //       chart.scrollbarY = new am4core.Scrollbar();

  //       let data = []
  //       let net = "หน่วย : ล้านบาท"
  //       // Add data
  //       for (let i = 0; i < res.length; i++) {
  //         if (res[i].coop_type == "7") {
  //           data.push({
  //             "year": res[i].year,
  //             "value": res[i].deposit_val
  //           })

  //         }
  //       }

  //       chart.data = data;
  //       chart.logo.disabled = true;

  //       // Export
  //       let title = chart.titles.create();
  //       title.fontSize = "11px";
  //       title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
  //       title.disabled = false;
  //       chart.exporting.menu = new am4core.ExportMenu();
  //       chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
  //       chart.exporting.useWebFonts = false;
  //       chart.exporting.validateSprites.push(title);
  //       chart.exporting.validateSprites.push(title.parent);

  //       /* Create axes */
  //       let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  //       categoryAxis.dataFields.category = "year";
  //       categoryAxis.renderer.grid.template.location = 0;
  //       categoryAxis.renderer.minGridDistance = 30;
  //       categoryAxis.renderer.labels.template.horizontalCenter = "right";
  //       categoryAxis.renderer.labels.template.verticalCenter = "middle";
  //       categoryAxis.renderer.labels.template.rotation = 270;
  //       categoryAxis.tooltip.disabled = true;
  //       categoryAxis.fontSize = "11px"
  //       // //categoryAxis.title.text = "ปีชุดข้อมูล"

  //       /* Create value axis */
  //       let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //       valueAxis.title.text = net
  //       valueAxis.fontSize = "11px"
  //       valueAxis.min = 0;
  //       /* Create series */
  //       let columnSeries = chart.series.push(new am4charts.ColumnSeries());
  //       columnSeries.name = "ปริมาณธุรกิจ";
  //       columnSeries.dataFields.valueY = "value";
  //       columnSeries.dataFields.categoryX = "year";

  //       columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
  //       columnSeries.columns.template.propertyFields.stroke = "stroke";
  //       columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
  //       columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
  //       columnSeries.tooltip.label.textAlign = "middle";

  //       let lineSeries = chart.series.push(new am4charts.LineSeries());
  //       lineSeries.name = "value";
  //       lineSeries.dataFields.valueY = "value";
  //       lineSeries.dataFields.categoryX = "year";

  //       lineSeries.stroke = am4core.color("#fdd400");
  //       lineSeries.strokeWidth = 3;
  //       lineSeries.propertyFields.strokeDasharray = "lineDash";
  //       lineSeries.tooltip.label.textAlign = "middle";

  //       let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
  //       bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       bullet.dy = -10;
  //       bullet.label.text = '{valueY}'
  //       bullet.label.fill = am4core.color('#EA4755')

  //     })

  //     // ปริมาณธุรกิจ เครดิต ประเภทให้กู้
  //     this.zone.runOutsideAngular(() => {
  //       am4core.useTheme(am4themes_animated);
  //       let chart = am4core.create("chartdiv_business_type7_credit_val", am4charts.XYChart);

  //       chart.scrollbarX = new am4core.Scrollbar();
  //       chart.scrollbarY = new am4core.Scrollbar();

  //       let data = []
  //       let net = "หน่วย : ล้านบาท"
  //       // Add data
  //       for (let i = 0; i < res.length; i++) {
  //         if (res[i].coop_type == "7") {
  //           data.push({
  //             "year": res[i].year,
  //             "value": res[i].credit_val
  //           })

  //         }
  //       }

  //       chart.data = data;
  //       chart.logo.disabled = true;

  //       // Export
  //       let title = chart.titles.create();
  //       title.fontSize = "11px";
  //       title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
  //       title.disabled = false;
  //       chart.exporting.menu = new am4core.ExportMenu();
  //       chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
  //       chart.exporting.useWebFonts = false;
  //       chart.exporting.validateSprites.push(title);
  //       chart.exporting.validateSprites.push(title.parent);

  //       /* Create axes */
  //       let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  //       categoryAxis.dataFields.category = "year";
  //       categoryAxis.renderer.grid.template.location = 0;
  //       categoryAxis.renderer.minGridDistance = 30;
  //       categoryAxis.renderer.labels.template.horizontalCenter = "right";
  //       categoryAxis.renderer.labels.template.verticalCenter = "middle";
  //       categoryAxis.renderer.labels.template.rotation = 270;
  //       categoryAxis.tooltip.disabled = true;
  //       categoryAxis.fontSize = "11px"
  //       // //categoryAxis.title.text = "ปีชุดข้อมูล"

  //       /* Create value axis */
  //       let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //       valueAxis.title.text = net
  //       valueAxis.fontSize = "11px"
  //       valueAxis.min = 0;
  //       /* Create series */
  //       let columnSeries = chart.series.push(new am4charts.ColumnSeries());
  //       columnSeries.name = "ปริมาณธุรกิจ";
  //       columnSeries.dataFields.valueY = "value";
  //       columnSeries.dataFields.categoryX = "year";

  //       columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
  //       columnSeries.columns.template.propertyFields.stroke = "stroke";
  //       columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
  //       columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
  //       columnSeries.tooltip.label.textAlign = "middle";

  //       let lineSeries = chart.series.push(new am4charts.LineSeries());
  //       lineSeries.name = "value";
  //       lineSeries.dataFields.valueY = "value";
  //       lineSeries.dataFields.categoryX = "year";

  //       lineSeries.stroke = am4core.color("#fdd400");
  //       lineSeries.strokeWidth = 3;
  //       lineSeries.propertyFields.strokeDasharray = "lineDash";
  //       lineSeries.tooltip.label.textAlign = "middle";

  //       let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
  //       bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       bullet.dy = -10;
  //       bullet.label.text = '{valueY}'
  //       bullet.label.fill = am4core.color('#EA4755')

  //     })

  //     // ปริมาณธุรกิจ เครดิต ประเภทจัดหา
  //     this.zone.runOutsideAngular(() => {
  //       am4core.useTheme(am4themes_animated);
  //       let chart = am4core.create("chartdiv_business_type7_sale_val", am4charts.XYChart);

  //       chart.scrollbarX = new am4core.Scrollbar();
  //       chart.scrollbarY = new am4core.Scrollbar();

  //       let data = []
  //       let net = "หน่วย : ล้านบาท"
  //       // Add data
  //       for (let i = 0; i < res.length; i++) {
  //         if (res[i].coop_type == "7") {
  //           data.push({
  //             "year": res[i].year,
  //             "value": res[i].sale_val
  //           })

  //         }
  //       }

  //       chart.data = data;
  //       chart.logo.disabled = true;

  //       // Export
  //       let title = chart.titles.create();
  //       title.fontSize = "11px";
  //       title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
  //       title.disabled = false;
  //       chart.exporting.menu = new am4core.ExportMenu();
  //       chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
  //       chart.exporting.useWebFonts = false;
  //       chart.exporting.validateSprites.push(title);
  //       chart.exporting.validateSprites.push(title.parent);

  //       /* Create axes */
  //       let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  //       categoryAxis.dataFields.category = "year";
  //       categoryAxis.renderer.grid.template.location = 0;
  //       categoryAxis.renderer.minGridDistance = 30;
  //       categoryAxis.renderer.labels.template.horizontalCenter = "right";
  //       categoryAxis.renderer.labels.template.verticalCenter = "middle";
  //       categoryAxis.renderer.labels.template.rotation = 270;
  //       categoryAxis.tooltip.disabled = true;
  //       categoryAxis.fontSize = "11px"
  //       // //categoryAxis.title.text = "ปีชุดข้อมูล"

  //       /* Create value axis */
  //       let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //       valueAxis.title.text = net
  //       valueAxis.fontSize = "11px"
  //       valueAxis.min = 0;
  //       /* Create series */
  //       let columnSeries = chart.series.push(new am4charts.ColumnSeries());
  //       columnSeries.name = "ปริมาณธุรกิจ";
  //       columnSeries.dataFields.valueY = "value";
  //       columnSeries.dataFields.categoryX = "year";

  //       columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
  //       columnSeries.columns.template.propertyFields.stroke = "stroke";
  //       columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
  //       columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
  //       columnSeries.tooltip.label.textAlign = "middle";

  //       let lineSeries = chart.series.push(new am4charts.LineSeries());
  //       lineSeries.name = "value";
  //       lineSeries.dataFields.valueY = "value";
  //       lineSeries.dataFields.categoryX = "year";

  //       lineSeries.stroke = am4core.color("#fdd400");
  //       lineSeries.strokeWidth = 3;
  //       lineSeries.propertyFields.strokeDasharray = "lineDash";
  //       lineSeries.tooltip.label.textAlign = "middle";

  //       let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
  //       bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       bullet.dy = -10;
  //       bullet.label.text = '{valueY}'
  //       bullet.label.fill = am4core.color('#EA4755')

  //     })

  //     // ปริมาณธุรกิจ เครดิต ประเภทรวบรวม
  //     this.zone.runOutsideAngular(() => {
  //       am4core.useTheme(am4themes_animated);
  //       let chart = am4core.create("chartdiv_business_type7_collect_val", am4charts.XYChart);

  //       chart.scrollbarX = new am4core.Scrollbar();
  //       chart.scrollbarY = new am4core.Scrollbar();

  //       let data = []
  //       let net = "หน่วย : ล้านบาท"
  //       // Add data
  //       for (let i = 0; i < res.length; i++) {
  //         if (res[i].coop_type == "7") {
  //           data.push({
  //             "year": res[i].year,
  //             "value": res[i].collect_val
  //           })

  //         }
  //       }

  //       chart.data = data;
  //       chart.logo.disabled = true;

  //       // Export
  //       let title = chart.titles.create();
  //       title.fontSize = "11px";
  //       title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
  //       title.disabled = false;
  //       chart.exporting.menu = new am4core.ExportMenu();
  //       chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
  //       chart.exporting.useWebFonts = false;
  //       chart.exporting.validateSprites.push(title);
  //       chart.exporting.validateSprites.push(title.parent);

  //       /* Create axes */
  //       let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  //       categoryAxis.dataFields.category = "year";
  //       categoryAxis.renderer.grid.template.location = 0;
  //       categoryAxis.renderer.minGridDistance = 30;
  //       categoryAxis.renderer.labels.template.horizontalCenter = "right";
  //       categoryAxis.renderer.labels.template.verticalCenter = "middle";
  //       categoryAxis.renderer.labels.template.rotation = 270;
  //       categoryAxis.tooltip.disabled = true;
  //       categoryAxis.fontSize = "11px"
  //       // //categoryAxis.title.text = "ปีชุดข้อมูล"

  //       /* Create value axis */
  //       let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //       valueAxis.title.text = net
  //       valueAxis.fontSize = "11px"
  //       valueAxis.min = 0;
  //       /* Create series */
  //       let columnSeries = chart.series.push(new am4charts.ColumnSeries());
  //       columnSeries.name = "ปริมาณธุรกิจ";
  //       columnSeries.dataFields.valueY = "value";
  //       columnSeries.dataFields.categoryX = "year";

  //       columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
  //       columnSeries.columns.template.propertyFields.stroke = "stroke";
  //       columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
  //       columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
  //       columnSeries.tooltip.label.textAlign = "middle";

  //       let lineSeries = chart.series.push(new am4charts.LineSeries());
  //       lineSeries.name = "value";
  //       lineSeries.dataFields.valueY = "value";
  //       lineSeries.dataFields.categoryX = "year";

  //       lineSeries.stroke = am4core.color("#fdd400");
  //       lineSeries.strokeWidth = 3;
  //       lineSeries.propertyFields.strokeDasharray = "lineDash";
  //       lineSeries.tooltip.label.textAlign = "middle";

  //       let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
  //       bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       bullet.dy = -10;
  //       bullet.label.text = '{valueY}'
  //       bullet.label.fill = am4core.color('#EA4755')

  //     })

  //     // ปริมาณธุรกิจ เครดิต ประเภทแปรรูป
  //     this.zone.runOutsideAngular(() => {
  //       am4core.useTheme(am4themes_animated);
  //       let chart = am4core.create("chartdiv_business_type7_transfrom_val", am4charts.XYChart);

  //       chart.scrollbarX = new am4core.Scrollbar();
  //       chart.scrollbarY = new am4core.Scrollbar();

  //       let data = []
  //       let net = "หน่วย : ล้านบาท"
  //       // Add data
  //       for (let i = 0; i < res.length; i++) {
  //         if (res[i].coop_type == "7") {
  //           data.push({
  //             "year": res[i].year,
  //             "value": res[i].transfrom_val
  //           })

  //         }
  //       }

  //       chart.data = data;
  //       chart.logo.disabled = true;

  //       // Export
  //       let title = chart.titles.create();
  //       title.fontSize = "11px";
  //       title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
  //       title.disabled = false;
  //       chart.exporting.menu = new am4core.ExportMenu();
  //       chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
  //       chart.exporting.useWebFonts = false;
  //       chart.exporting.validateSprites.push(title);
  //       chart.exporting.validateSprites.push(title.parent);

  //       /* Create axes */
  //       let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  //       categoryAxis.dataFields.category = "year";
  //       categoryAxis.renderer.grid.template.location = 0;
  //       categoryAxis.renderer.minGridDistance = 30;
  //       categoryAxis.renderer.labels.template.horizontalCenter = "right";
  //       categoryAxis.renderer.labels.template.verticalCenter = "middle";
  //       categoryAxis.renderer.labels.template.rotation = 270;
  //       categoryAxis.tooltip.disabled = true;
  //       categoryAxis.fontSize = "11px"
  //       // //categoryAxis.title.text = "ปีชุดข้อมูล"

  //       /* Create value axis */
  //       let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //       valueAxis.title.text = net
  //       valueAxis.fontSize = "11px"
  //       valueAxis.min = 0;
  //       /* Create series */
  //       let columnSeries = chart.series.push(new am4charts.ColumnSeries());
  //       columnSeries.name = "ปริมาณธุรกิจ";
  //       columnSeries.dataFields.valueY = "value";
  //       columnSeries.dataFields.categoryX = "year";

  //       columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
  //       columnSeries.columns.template.propertyFields.stroke = "stroke";
  //       columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
  //       columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
  //       columnSeries.tooltip.label.textAlign = "middle";

  //       let lineSeries = chart.series.push(new am4charts.LineSeries());
  //       lineSeries.name = "value";
  //       lineSeries.dataFields.valueY = "value";
  //       lineSeries.dataFields.categoryX = "year";

  //       lineSeries.stroke = am4core.color("#fdd400");
  //       lineSeries.strokeWidth = 3;
  //       lineSeries.propertyFields.strokeDasharray = "lineDash";
  //       lineSeries.tooltip.label.textAlign = "middle";

  //       let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
  //       bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       bullet.dy = -10;
  //       bullet.label.text = '{valueY}'
  //       bullet.label.fill = am4core.color('#EA4755')

  //     })

  //     // ปริมาณธุรกิจ เครดิต ประเภทบริการ
  //     this.zone.runOutsideAngular(() => {
  //       am4core.useTheme(am4themes_animated);
  //       let chart = am4core.create("chartdiv_business_type7_service_val", am4charts.XYChart);

  //       chart.scrollbarX = new am4core.Scrollbar();
  //       chart.scrollbarY = new am4core.Scrollbar();

  //       let data = []
  //       let net = "หน่วย : ล้านบาท"
  //       // Add data
  //       for (let i = 0; i < res.length; i++) {
  //         if (res[i].coop_type == "7") {
  //           data.push({
  //             "year": res[i].year,
  //             "value": res[i].service_val
  //           })

  //         }
  //       }

  //       chart.data = data;
  //       chart.logo.disabled = true;

  //       // Export
  //       let title = chart.titles.create();
  //       title.fontSize = "11px";
  //       title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
  //       title.disabled = false;
  //       chart.exporting.menu = new am4core.ExportMenu();
  //       chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
  //       chart.exporting.useWebFonts = false;
  //       chart.exporting.validateSprites.push(title);
  //       chart.exporting.validateSprites.push(title.parent);

  //       /* Create axes */
  //       let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  //       categoryAxis.dataFields.category = "year";
  //       categoryAxis.renderer.grid.template.location = 0;
  //       categoryAxis.renderer.minGridDistance = 30;
  //       categoryAxis.renderer.labels.template.horizontalCenter = "right";
  //       categoryAxis.renderer.labels.template.verticalCenter = "middle";
  //       categoryAxis.renderer.labels.template.rotation = 270;
  //       categoryAxis.tooltip.disabled = true;
  //       categoryAxis.fontSize = "11px"
  //       // //categoryAxis.title.text = "ปีชุดข้อมูล"

  //       /* Create value axis */
  //       let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //       valueAxis.title.text = net
  //       valueAxis.fontSize = "11px"
  //       valueAxis.min = 0;
  //       /* Create series */
  //       let columnSeries = chart.series.push(new am4charts.ColumnSeries());
  //       columnSeries.name = "ปริมาณธุรกิจ";
  //       columnSeries.dataFields.valueY = "value";
  //       columnSeries.dataFields.categoryX = "year";

  //       columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
  //       columnSeries.columns.template.propertyFields.stroke = "stroke";
  //       columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
  //       columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
  //       columnSeries.tooltip.label.textAlign = "middle";

  //       let lineSeries = chart.series.push(new am4charts.LineSeries());
  //       lineSeries.name = "value";
  //       lineSeries.dataFields.valueY = "value";
  //       lineSeries.dataFields.categoryX = "year";

  //       lineSeries.stroke = am4core.color("#fdd400");
  //       lineSeries.strokeWidth = 3;
  //       lineSeries.propertyFields.strokeDasharray = "lineDash";
  //       lineSeries.tooltip.label.textAlign = "middle";

  //       let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
  //       bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
  //       bullet.dy = -10;
  //       bullet.label.text = '{valueY}'
  //       bullet.label.fill = am4core.color('#EA4755')

  //     })
  //   })

  // }

  Participation() {
    this.FamerServiceService.GetAgriProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"

        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_deposit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })
          }

        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_credit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_sale) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_good) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }


        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_marketing) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_service) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_other) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation1() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation2() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation3() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation4() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation5() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation6() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation7() {
    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  geochart = () => {
    this.SpinnerService.show();
    // this.CoopServiceService.GetCoopStatusProvinceYearOne(this.datayear).subscribe(res => {
    this.FamerServiceService.GetOracleSumProvinceYearSearchAgri(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      this.StatusProvinceYearOne = res;

      // for (let i = 0; i < res.length; i++) {

      this.StatusProvinceYearOne_chart = google.visualization.arrayToDataTable([

        ['provinces', 'จำนวนรวม', 'สถานะ Active', 'Non-active'],


        [res[0]["provinceName"], res[0]["sum"], res[0]["active"], res[0]["nonActive"]],
        [res[1]["provinceName"], res[1]["sum"], res[1]["active"], res[1]["nonActive"]],
        [res[2]["provinceName"], res[2]["sum"], res[2]["active"], res[2]["nonActive"]],
        [res[3]["provinceName"], res[3]["sum"], res[3]["active"], res[3]["nonActive"]],
        [res[4]["provinceName"], res[4]["sum"], res[4]["active"], res[4]["nonActive"]],
        [res[5]["provinceName"], res[5]["sum"], res[5]["active"], res[5]["nonActive"]],
        [res[6]["provinceName"], res[6]["sum"], res[6]["active"], res[6]["nonActive"]],
        [res[7]["provinceName"], res[7]["sum"], res[7]["active"], res[7]["nonActive"]],
        [res[8]["provinceName"], res[8]["sum"], res[8]["active"], res[8]["nonActive"]],
        [res[9]["provinceName"], res[9]["sum"], res[9]["active"], res[9]["nonActive"]],
        [res[10]["provinceName"], res[10]["sum"], res[10]["active"], res[10]["nonActive"]],
        [res[11]["provinceName"], res[11]["sum"], res[11]["active"], res[11]["nonActive"]],
        [res[12]["provinceName"], res[12]["sum"], res[12]["active"], res[12]["nonActive"]],
        [res[13]["provinceName"], res[13]["sum"], res[13]["active"], res[13]["nonActive"]],
        [res[14]["provinceName"], res[14]["sum"], res[14]["active"], res[14]["nonActive"]],
        [res[15]["provinceName"], res[15]["sum"], res[15]["active"], res[15]["nonActive"]],
        [res[16]["provinceName"], res[16]["sum"], res[16]["active"], res[16]["nonActive"]],
        [res[17]["provinceName"], res[17]["sum"], res[17]["active"], res[17]["nonActive"]],
        [res[18]["provinceName"], res[18]["sum"], res[18]["active"], res[18]["nonActive"]],
        [res[19]["provinceName"], res[19]["sum"], res[19]["active"], res[19]["nonActive"]],
        [res[20]["provinceName"], res[20]["sum"], res[20]["active"], res[20]["nonActive"]],
        [res[21]["provinceName"], res[21]["sum"], res[21]["active"], res[21]["nonActive"]],
        [res[22]["provinceName"], res[22]["sum"], res[22]["active"], res[22]["nonActive"]],
        [res[23]["provinceName"], res[23]["sum"], res[23]["active"], res[23]["nonActive"]],
        [res[24]["provinceName"], res[24]["sum"], res[24]["active"], res[24]["nonActive"]],
        [res[25]["provinceName"], res[25]["sum"], res[25]["active"], res[25]["nonActive"]],
        [res[26]["provinceName"], res[26]["sum"], res[26]["active"], res[26]["nonActive"]],
        [res[27]["provinceName"], res[27]["sum"], res[27]["active"], res[27]["nonActive"]],
        [res[28]["provinceName"], res[28]["sum"], res[28]["active"], res[28]["nonActive"]],
        [res[29]["provinceName"], res[29]["sum"], res[29]["active"], res[29]["nonActive"]],
        [res[30]["provinceName"], res[30]["sum"], res[30]["active"], res[30]["nonActive"]],
        [res[31]["provinceName"], res[31]["sum"], res[31]["active"], res[31]["nonActive"]],
        [res[32]["provinceName"], res[32]["sum"], res[32]["active"], res[32]["nonActive"]],
        [res[33]["provinceName"], res[33]["sum"], res[33]["active"], res[33]["nonActive"]],
        [res[34]["provinceName"], res[34]["sum"], res[34]["active"], res[34]["nonActive"]],
        [res[35]["provinceName"], res[35]["sum"], res[35]["active"], res[35]["nonActive"]],
        [res[36]["provinceName"], res[36]["sum"], res[36]["active"], res[36]["nonActive"]],
        [res[37]["provinceName"], res[37]["sum"], res[37]["active"], res[37]["nonActive"]],
        [res[38]["provinceName"], res[38]["sum"], res[38]["active"], res[38]["nonActive"]],
        [res[39]["provinceName"], res[39]["sum"], res[39]["active"], res[39]["nonActive"]],
        [res[40]["provinceName"], res[40]["sum"], res[40]["active"], res[40]["nonActive"]],
        [res[41]["provinceName"], res[41]["sum"], res[41]["active"], res[41]["nonActive"]],
        [res[42]["provinceName"], res[42]["sum"], res[42]["active"], res[42]["nonActive"]],
        [res[43]["provinceName"], res[43]["sum"], res[43]["active"], res[43]["nonActive"]],
        [res[44]["provinceName"], res[44]["sum"], res[44]["active"], res[44]["nonActive"]],
        [res[45]["provinceName"], res[45]["sum"], res[45]["active"], res[45]["nonActive"]],
        [res[46]["provinceName"], res[46]["sum"], res[46]["active"], res[46]["nonActive"]],
        [res[47]["provinceName"], res[47]["sum"], res[47]["active"], res[47]["nonActive"]],
        [res[48]["provinceName"], res[48]["sum"], res[48]["active"], res[48]["nonActive"]],
        [res[49]["provinceName"], res[49]["sum"], res[49]["active"], res[49]["nonActive"]],
        [res[50]["provinceName"], res[50]["sum"], res[50]["active"], res[50]["nonActive"]],
        [res[51]["provinceName"], res[51]["sum"], res[51]["active"], res[51]["nonActive"]],
        [res[52]["provinceName"], res[52]["sum"], res[52]["active"], res[52]["nonActive"]],
        [res[53]["provinceName"], res[53]["sum"], res[53]["active"], res[53]["nonActive"]],
        [res[54]["provinceName"], res[54]["sum"], res[54]["active"], res[54]["nonActive"]],
        [res[55]["provinceName"], res[55]["sum"], res[55]["active"], res[55]["nonActive"]],
        [res[56]["provinceName"], res[56]["sum"], res[56]["active"], res[56]["nonActive"]],
        [res[57]["provinceName"], res[57]["sum"], res[57]["active"], res[57]["nonActive"]],
        [res[58]["provinceName"], res[58]["sum"], res[58]["active"], res[58]["nonActive"]],
        [res[59]["provinceName"], res[59]["sum"], res[59]["active"], res[59]["nonActive"]],
        [res[60]["provinceName"], res[60]["sum"], res[60]["active"], res[60]["nonActive"]],
        [res[61]["provinceName"], res[61]["sum"], res[61]["active"], res[61]["nonActive"]],
        [res[62]["provinceName"], res[62]["sum"], res[62]["active"], res[62]["nonActive"]],
        [res[63]["provinceName"], res[63]["sum"], res[63]["active"], res[63]["nonActive"]],
        [res[64]["provinceName"], res[64]["sum"], res[64]["active"], res[64]["nonActive"]],
        [res[65]["provinceName"], res[65]["sum"], res[65]["active"], res[65]["nonActive"]],
        [res[66]["provinceName"], res[66]["sum"], res[66]["active"], res[66]["nonActive"]],
        [res[67]["provinceName"], res[67]["sum"], res[67]["active"], res[67]["nonActive"]],
        [res[68]["provinceName"], res[68]["sum"], res[68]["active"], res[68]["nonActive"]],
        [res[69]["provinceName"], res[69]["sum"], res[69]["active"], res[69]["nonActive"]],
        [res[70]["provinceName"], res[70]["sum"], res[70]["active"], res[70]["nonActive"]],
        [res[71]["provinceName"], res[71]["sum"], res[71]["active"], res[71]["nonActive"]],
        [res[72]["provinceName"], res[72]["sum"], res[72]["active"], res[72]["nonActive"]],
        [res[73]["provinceName"], res[73]["sum"], res[73]["active"], res[73]["nonActive"]],
        [res[74]["provinceName"], res[74]["sum"], res[74]["active"], res[74]["nonActive"]],
        [res[75]["provinceName"], res[75]["sum"], res[75]["active"], res[75]["nonActive"]],
        [res[76]["provinceName"], res[76]["sum"], res[76]["active"], res[76]["nonActive"]],
        // [res[77]["provinceName"], res[77]["sum"], res[77]["active"], res[77]["nonActive"]],


      ]);
      // }


      const options = {
        region: 'TH',
        resolution: 'provinces',
        tooltip: {
          isHtml: true,
          width: "100%", height: "100%"
        },
        Default: { enable: true, zoomFactor: 10 },
        defaultColor: '#f5f5f5',
        chartArea: { width: "100%", height: "100%" },
        colorAxis: {
          colors: ['#D0EFFF', '#2A9DF4', '#187BCD', '#1167B1', '#03254C'],
        }
      };

      var view = new google.visualization.DataView(this.StatusProvinceYearOne_chart);
      view.setColumns([0, 1, 2]);

      const chart = new google.visualization.GeoChart(document.getElementById('Coop_regions'));

      google.visualization.events.addListener(chart, 'select', function () {
        var selectionIdx = chart.getSelection()[0].row;
        var countryName = view.getValue(selectionIdx, 0);
        // window.open('http://localhost:4200/Coop-info/' + countryName);
        window.open('.#/Agri-info/' + countryName);
        // window.open('http://172.17.2.103:888/Coop-info/' + countryName);
        // window.open('http://61.19.210.103:888/Coop-info/' + countryName);
        // window.open('http://122.155.201.148/Coop-info/' + countryName); //cat

      });

      chart.draw(view, options);
      this.SpinnerService.hide();

    });

  }

  // totalCoop() {
  //   this.router.navigate(["/Coop-Map"]);
  // }

  // memberCoop() {
  //   this.router.navigate(["/Member-All"]);
  // }

  // totalfamer() {
  //   this.router.navigate(["/famer-all"]);
  // }

  // memberfamer() {
  //   this.router.navigate(["/Member-famer"]);
  // }

  GetAgriSumOfficer() {
    // return new Promise(async (resolve, reject) => {});
    this.FamerServiceService.GetAgriSumOfficer(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopOfficerYearMember = 0;
      this.CoopOfficerYearMemberM = 0;
      this.CoopOfficerYearMemberFm = 0;

      for (let i = 0; i < res.length; i++) {
        this.CoopOfficerYearMember += res[i].sum;
        this.CoopOfficerYearMemberM += res[i].dataM;
        this.CoopOfficerYearMemberFm += res[i].dataFm;
      }
    })
  }

  GetAgriSumMemberNewYearDataSum() {
    this.FamerServiceService.GetAgriSumMemberNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.MemberYearDataSum = 0;
      this.MemberYearDataM = 0;
      this.MemberYearDataFm = 0;

      for (let i = 0; i < res.length; i++) {
        this.MemberYearDataSum += res[i].sum;
        this.MemberYearDataM += res[i].dataM;
        this.MemberYearDataFm += res[i].dataFm;
      }
    })
  }

  GetAgriSumCommitteeNewYear() {
    this.FamerServiceService.GetAgriSumCommitteeNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CommitteeYearM = 0;
      this.CommitteeYearFM = 0;
      this.Committee = 0;
      this.CommitteeYear = 0;

      for (let i = 0; i < res.length; i++) {
        this.CommitteeYearM += res[i].dataM;
        this.CommitteeYearFM += res[i].dataFm;
        this.Committee = res[i].sum;
        this.CommitteeYear += this.Committee;
      }
    })
  }

  // GetCoopTypeLevelCount() {
  //   this.CoopServiceService.GetCoopTypeLevelCount(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
  //     this.CoopTypeLevelCount = res;
  //     for (let i = 0; i < res.length; i++) {

  //       if (res[i].level == "1") {
  //         this.TypeLevelSum1 += res[i].count;
  //         if (res[i].type == "1") {
  //           this.TypeLevel1_type1 = res[i].count;
  //         }
  //         else if (res[i].type == "2") {
  //           this.TypeLevel1_type2 = res[i].count;
  //         }
  //         else if (res[i].type == "3") {
  //           this.TypeLevel1_type3 = res[i].count;
  //         }
  //         else if (res[i].type == "4") {
  //           this.TypeLevel1_type4 = res[i].count;
  //         }
  //         else if (res[i].type == "5") {
  //           this.TypeLevel1_type5 = res[i].count;
  //         }
  //         else if (res[i].type == "6") {
  //           this.TypeLevel1_type6 = res[i].count;
  //         }
  //         else if (res[i].type == "7") {
  //           this.TypeLevel1_type7 = res[i].count;
  //         }
  //       }
  //       else if (res[i].level == "2") {
  //         this.TypeLevelSum2 += res[i].count;
  //         if (res[i].type == "1") {
  //           this.TypeLevel2_type1 = res[i].count;
  //         }
  //         else if (res[i].type == "2") {
  //           this.TypeLevel2_type2 = res[i].count;
  //         }
  //         else if (res[i].type == "3") {
  //           this.TypeLevel2_type3 = res[i].count;
  //         }
  //         else if (res[i].type == "4") {
  //           this.TypeLevel2_type4 = res[i].count;
  //         }
  //         else if (res[i].type == "5") {
  //           this.TypeLevel2_type5 = res[i].count;
  //         }
  //         else if (res[i].type == "6") {
  //           this.TypeLevel2_type6 = res[i].count;
  //         }
  //         else if (res[i].type == "7") {
  //           this.TypeLevel2_type7 = res[i].count;
  //         }
  //       }
  //       else if (res[i].level == "3") {
  //         this.TypeLevelSum3 += res[i].count;
  //         if (res[i].type == "1") {
  //           this.TypeLevel3_type1 = res[i].count;
  //         }
  //         else if (res[i].type == "2") {
  //           this.TypeLevel3_type2 = res[i].count;
  //         }
  //         else if (res[i].type == "3") {
  //           this.TypeLevel3_type3 = res[i].count;
  //         }
  //         else if (res[i].type == "4") {
  //           this.TypeLevel3_type4 = res[i].count;
  //         }
  //         else if (res[i].type == "5") {
  //           this.TypeLevel3_type5 = res[i].count;
  //         }
  //         else if (res[i].type == "6") {
  //           this.TypeLevel3_type6 = res[i].count;
  //         }
  //         else if (res[i].type == "7") {
  //           this.TypeLevel3_type7 = res[i].count;
  //         }
  //       }
  //       else if (res[i].level == "4") {
  //         this.TypeLevelSum4 += res[i].count;

  //         if (res[i].type == "1") {
  //           this.TypeLevel4_type1 = res[i].count;
  //         }
  //         else if (res[i].type == "2") {
  //           this.TypeLevel4_type2 = res[i].count;
  //         }
  //         else if (res[i].type == "3") {
  //           this.TypeLevel4_type3 = res[i].count;
  //         }
  //         else if (res[i].type == "4") {
  //           this.TypeLevel4_type4 = res[i].count;
  //         }
  //         else if (res[i].type == "5") {
  //           this.TypeLevel4_type5 = res[i].count;
  //         }
  //         else if (res[i].type == "6") {
  //           this.TypeLevel4_type6 = res[i].count;
  //         }
  //         else if (res[i].type == "7") {
  //           this.TypeLevel4_type7 = res[i].count;
  //         }
  //       }
  //     }
  //   })
  // }

  GetAgriOracleTypesNew() {
    this.FamerServiceService.GetAgriOracleTypesNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopOracleTypes = res;

      this.Active_coopType1 = 0;
      this.InActive_coopType1 = 0;

      for (let i = 0; i < res.length; i++) {

        this.Active_coopType1 += res[i].active
        this.InActive_coopType1 += res[i].nonActive
        if (res[i].coopType == "1") {
          this.typeName = "กลุ่มเกษตรกรทำนา";
        }
        else if (res[i].coopType == "2") {
          this.typeName = "กลุ่มเกษตรกรทำไร่";
        }
        else if (res[i].coopType == "3") {
          this.typeName = "กลุ่มเกษตรกรทำสวน";
        }
        else if (res[i].coopType == "4") {
          this.typeName = "กลุ่มเกษตรกรประมง";
        }
        else if (res[i].coopType == "5") {
          this.typeName = "กลุ่มเกษตรกรเลี้ยงสัตว์";
        }
        else if (res[i].coopType == "6") {
          this.typeName = "กลุ่มเกษตรกรอื่นๆ";
        }
        // else if (res[i].coopType == "7") {
        //   this.typeName = "สหกรณ์เครดิตยูเนี่ยน";
        // }
      }
    })
  }

  GetAgriBussiness() {
    this.FamerServiceService.GetAgriBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      for (let i = 0; i < res.length; i++) {

        let year_now1
        let year_now2
        let year_now3
        let year_now4
        let year_now5

        for (let i = 0; i < res.length; i++) {

          if (res[0].year) {
            this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            year_now1 = res[i].year;

          }
          else if (res[1].year) {
            this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            year_now2 = res[i].year;
          }
          else if (res[2].year) {
            this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            year_now3 = res[i].year;
          }
          else if (res[3].year) {
            this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            year_now4 = res[i].year;
          }
          else if (res[4].year) {
            this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            year_now5 = res[i].year;
          }

        }


      }
      // this.SpinnerService.hide();

    })
  }

  select_TypeAgri(data) {
    this.TypeAgri = data;
    if (this.TypeAgri == "TypeAgri") {
      this.TypeAgri = true;
      this.TypeCoop = false;
    }
    this.ngAfterViewInit();

  }

  select_TypeCoop(data) {
    this.TypeCoop = data;
    if (this.TypeCoop == "TypeCoop") {
      this.TypeCoop = true;
      this.TypeAgri = false;
    }

    this.ngAfterViewInit();
  }

  MemberGeo_Coop = () => {
    this.SpinnerService.show();
    // this.CoopServiceService.GetCoopMemberProvinceYears(this.datayear).subscribe(res => {
    this.FamerServiceService.GetCoopMemberProvinceYearSearchAgri(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.MemberProvinceYears = res;

      this.DataSetMember = google.visualization.arrayToDataTable([

        ['provinces', 'จำนวนสมาชิกกลุ่มเกษตกร'],

        [res[0]["provinceName"], res[0]["sum"]],
        [res[1]["provinceName"], res[1]["sum"]],
        [res[2]["provinceName"], res[2]["sum"]],
        [res[3]["provinceName"], res[3]["sum"]],
        [res[4]["provinceName"], res[4]["sum"]],
        [res[5]["provinceName"], res[5]["sum"]],
        [res[6]["provinceName"], res[6]["sum"]],
        [res[7]["provinceName"], res[7]["sum"]],
        [res[8]["provinceName"], res[8]["sum"]],
        [res[9]["provinceName"], res[9]["sum"]],
        [res[10]["provinceName"], res[10]["sum"]],
        [res[11]["provinceName"], res[11]["sum"]],
        [res[12]["provinceName"], res[12]["sum"]],
        [res[13]["provinceName"], res[13]["sum"]],
        [res[14]["provinceName"], res[14]["sum"]],
        [res[15]["provinceName"], res[15]["sum"]],
        [res[16]["provinceName"], res[16]["sum"]],
        [res[17]["provinceName"], res[17]["sum"]],
        [res[18]["provinceName"], res[18]["sum"]],
        [res[19]["provinceName"], res[19]["sum"]],
        [res[20]["provinceName"], res[20]["sum"]],
        [res[21]["provinceName"], res[21]["sum"]],
        [res[22]["provinceName"], res[22]["sum"]],
        [res[23]["provinceName"], res[23]["sum"]],
        [res[24]["provinceName"], res[24]["sum"]],
        [res[25]["provinceName"], res[25]["sum"]],
        [res[26]["provinceName"], res[26]["sum"]],
        [res[27]["provinceName"], res[27]["sum"]],
        [res[28]["provinceName"], res[28]["sum"]],
        [res[29]["provinceName"], res[29]["sum"]],
        [res[30]["provinceName"], res[30]["sum"]],
        [res[31]["provinceName"], res[31]["sum"]],
        [res[32]["provinceName"], res[32]["sum"]],
        [res[33]["provinceName"], res[33]["sum"]],
        [res[34]["provinceName"], res[34]["sum"]],
        [res[35]["provinceName"], res[35]["sum"]],
        [res[36]["provinceName"], res[36]["sum"]],
        [res[37]["provinceName"], res[37]["sum"]],
        [res[38]["provinceName"], res[38]["sum"]],
        [res[39]["provinceName"], res[39]["sum"]],
        [res[40]["provinceName"], res[40]["sum"]],
        [res[41]["provinceName"], res[41]["sum"]],
        [res[42]["provinceName"], res[42]["sum"]],
        [res[43]["provinceName"], res[43]["sum"]],
        [res[44]["provinceName"], res[44]["sum"]],
        [res[45]["provinceName"], res[45]["sum"]],
        [res[46]["provinceName"], res[46]["sum"]],
        [res[47]["provinceName"], res[47]["sum"]],
        [res[48]["provinceName"], res[48]["sum"]],
        [res[49]["provinceName"], res[49]["sum"]],
        [res[50]["provinceName"], res[50]["sum"]],
        [res[51]["provinceName"], res[51]["sum"]],
        [res[52]["provinceName"], res[52]["sum"]],
        [res[53]["provinceName"], res[53]["sum"]],
        [res[54]["provinceName"], res[54]["sum"]],
        [res[55]["provinceName"], res[55]["sum"]],
        [res[56]["provinceName"], res[56]["sum"]],
        [res[57]["provinceName"], res[57]["sum"]],
        [res[58]["provinceName"], res[58]["sum"]],
        [res[59]["provinceName"], res[59]["sum"]],
        [res[60]["provinceName"], res[60]["sum"]],
        [res[61]["provinceName"], res[61]["sum"]],
        [res[62]["provinceName"], res[62]["sum"]],
        [res[63]["provinceName"], res[63]["sum"]],
        [res[64]["provinceName"], res[64]["sum"]],
        [res[65]["provinceName"], res[65]["sum"]],
        [res[66]["provinceName"], res[66]["sum"]],
        [res[67]["provinceName"], res[67]["sum"]],
        [res[68]["provinceName"], res[68]["sum"]],
        [res[69]["provinceName"], res[69]["sum"]],
        [res[70]["provinceName"], res[70]["sum"]],
        [res[71]["provinceName"], res[71]["sum"]],
        [res[72]["provinceName"], res[72]["sum"]],
        [res[73]["provinceName"], res[73]["sum"]],
        [res[74]["provinceName"], res[74]["sum"]],
        [res[75]["provinceName"], res[75]["sum"]],
        [res[76]["provinceName"], res[76]["sum"]]
      ])


      const options = {
        region: 'TH',
        resolution: 'provinces',
        chartArea: { width: "100%", height: "100%" },
        colorAxis: {
          colors: ['#F7EBEB', '#F9CDD4', '#E27589', '#7C3042'],
        }
      };

      var view = new google.visualization.DataView(this.DataSetMember);
      view.setColumns([0, 1]);

      const chart = new google.visualization.GeoChart(document.getElementById('MapMember'));

      google.visualization.events.addListener(chart, 'select', function () {
        var selectionIdx = chart.getSelection()[0].row;
        var countryName = view.getValue(selectionIdx, 0);
        // window.open('http://localhost:4200/Coop-info/' + countryName);
        window.open('.#/Agri-info/' + countryName);
        // window.open('http://172.17.2.103:888/Coop-info/' + countryName);
        // window.open('http://61.19.210.103:888/Coop-info/' + countryName);
        // window.open('http://122.155.201.148/Coop-info/' + countryName); //cat

      });
      chart.draw(this.DataSetMember, options);
      this.SpinnerService.hide();

    })
  }

  geochart_ฺbusiness_Coop = () => {
    this.SpinnerService.show();
    // this.CoopServiceService.GetCoopBusinessMap(this.datayear).subscribe(res => {
    this.FamerServiceService.GetBussinessProvinceYearSumAgri(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      // for (let i = 0; i < res.length; i++) {

      this.CoopBusinessMap_Chart = google.visualization.arrayToDataTable([

        ['จังหวัด', 'จำนวนปริมาณธุรกิจกลุ่มเกษตกร'],

        [res[0]["provinceName"], res[0]["sum"]],
        [res[1]["provinceName"], res[1]["sum"]],
        [res[2]["provinceName"], res[2]["sum"]],
        [res[3]["provinceName"], res[3]["sum"]],
        [res[4]["provinceName"], res[4]["sum"]],
        [res[5]["provinceName"], res[5]["sum"]],
        [res[6]["provinceName"], res[6]["sum"]],
        [res[7]["provinceName"], res[7]["sum"]],
        [res[8]["provinceName"], res[8]["sum"]],
        [res[9]["provinceName"], res[9]["sum"]],
        [res[10]["provinceName"], res[10]["sum"]],
        [res[11]["provinceName"], res[11]["sum"]],
        [res[12]["provinceName"], res[12]["sum"]],
        [res[13]["provinceName"], res[13]["sum"]],
        [res[14]["provinceName"], res[14]["sum"]],
        [res[15]["provinceName"], res[15]["sum"]],
        [res[16]["provinceName"], res[16]["sum"]],
        [res[17]["provinceName"], res[17]["sum"]],
        [res[18]["provinceName"], res[18]["sum"]],
        [res[19]["provinceName"], res[19]["sum"]],
        [res[20]["provinceName"], res[20]["sum"]],
        [res[21]["provinceName"], res[21]["sum"]],
        [res[22]["provinceName"], res[22]["sum"]],
        [res[23]["provinceName"], res[23]["sum"]],
        [res[24]["provinceName"], res[24]["sum"]],
        [res[25]["provinceName"], res[25]["sum"]],
        [res[26]["provinceName"], res[26]["sum"]],
        [res[27]["provinceName"], res[27]["sum"]],
        [res[28]["provinceName"], res[28]["sum"]],
        [res[29]["provinceName"], res[29]["sum"]],
        [res[30]["provinceName"], res[30]["sum"]],
        [res[31]["provinceName"], res[31]["sum"]],
        [res[32]["provinceName"], res[32]["sum"]],
        [res[33]["provinceName"], res[33]["sum"]],
        [res[34]["provinceName"], res[34]["sum"]],
        [res[35]["provinceName"], res[35]["sum"]],
        [res[36]["provinceName"], res[36]["sum"]],
        [res[37]["provinceName"], res[37]["sum"]],
        [res[38]["provinceName"], res[38]["sum"]],
        [res[39]["provinceName"], res[39]["sum"]],
        [res[40]["provinceName"], res[40]["sum"]],
        [res[41]["provinceName"], res[41]["sum"]],
        [res[42]["provinceName"], res[42]["sum"]],
        [res[43]["provinceName"], res[43]["sum"]],
        [res[44]["provinceName"], res[44]["sum"]],
        [res[45]["provinceName"], res[45]["sum"]],
        [res[46]["provinceName"], res[46]["sum"]],
        [res[47]["provinceName"], res[47]["sum"]],
        [res[48]["provinceName"], res[48]["sum"]],
        [res[49]["provinceName"], res[49]["sum"]],
        [res[50]["provinceName"], res[50]["sum"]],
        [res[51]["provinceName"], res[51]["sum"]],
        [res[52]["provinceName"], res[52]["sum"]],
        [res[53]["provinceName"], res[53]["sum"]],
        [res[54]["provinceName"], res[54]["sum"]],
        [res[55]["provinceName"], res[55]["sum"]],
        [res[56]["provinceName"], res[56]["sum"]],
        [res[57]["provinceName"], res[57]["sum"]],
        [res[58]["provinceName"], res[58]["sum"]],
        [res[59]["provinceName"], res[59]["sum"]],
        [res[60]["provinceName"], res[60]["sum"]],
        [res[61]["provinceName"], res[61]["sum"]],
        [res[62]["provinceName"], res[62]["sum"]],
        [res[63]["provinceName"], res[63]["sum"]],
        [res[64]["provinceName"], res[64]["sum"]],
        [res[65]["provinceName"], res[65]["sum"]],
        [res[66]["provinceName"], res[66]["sum"]],
        [res[67]["provinceName"], res[67]["sum"]],
        [res[68]["provinceName"], res[68]["sum"]],
        [res[69]["provinceName"], res[69]["sum"]],
        [res[70]["provinceName"], res[70]["sum"]],
        [res[71]["provinceName"], res[71]["sum"]],
        [res[72]["provinceName"], res[72]["sum"]],
        [res[73]["provinceName"], res[73]["sum"]],
        [res[74]["provinceName"], res[74]["sum"]],
        [res[75]["provinceName"], res[75]["sum"]],
        [res[76]["provinceName"], res[76]["sum"]],

      ]);


      const options = {
        region: 'TH',
        resolution: 'provinces',
        chartArea: { width: "100%", height: "100%" },
        colorAxis: {
          colors: ['#F2FBF8', '#3BC795', '#1F6D51', '#12402F'],
        }
      };

      var view = new google.visualization.DataView(this.CoopBusinessMap_Chart);
      view.setColumns([0, 1]);

      const chart = new google.visualization.GeoChart(document.getElementById('Coop_regions_member'));
      google.visualization.events.addListener(chart, 'select', function () {
        var selectionIdx = chart.getSelection()[0].row;
        var countryName = view.getValue(selectionIdx, 0);
        // window.open('http://localhost:4200/Coop-info/' + countryName);
        window.open('.#/Agri-info/' + countryName);
        // window.open('http://172.17.2.103:888/Coop-info/' + countryName);
        // window.open('http://61.19.210.103:888/Coop-info/' + countryName);
        // window.open('http://122.155.201.148/Coop-info/' + countryName); //cat

      });
      chart.draw(view, options);
      this.SpinnerService.hide();
    });

  }

  // geochart_shortComings_Coop = () => {

  //   this.CoopServiceService.GetDefectProvinceYearSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(async res => {

  //     if (this.auth_data && (this.auth_data['role'] == 'District_inspector' || this.auth_data['role'] == 'Provincial_officials')) {
  //       this.AuthenService.GetProvinceByUserid(this.auth_data['user_id']).subscribe(
  //         res1 => {
  //           let arr = [];
  //           arr.push(['จังหวัด', 'จำนวนข้อบกพร่อง : ร้อยละ']);

  //           for (let i = 0; i < res1.length; i++) {
  //             for (let j = 0; j < res.length; j++) {
  //               if (res1[i]['provinceNameSort'].trim() == res[j]['provinceName']) {
  //                 // arr.push([res[j]["provinceName"], res[j]["sumCompair"]]);
  //                 arr.push([res[j]["provinceName"], res[j]["numCoopDefect"]]);
  //                 break;
  //               }
  //             }
  //           }

  //           this.shortComingsCoop_Chart = google.visualization.arrayToDataTable(
  //             arr
  //           );
  //         }
  //       );

  //     } else {
  //       this.shortComingsCoop_Chart = google.visualization.arrayToDataTable([

  //         ['จังหวัด', 'จำนวนข้อบกพร่อง : ร้อยละ'],

  //         [res[0]["provinceName"], res[0]["numCoopDefect"]],
  //         [res[1]["provinceName"], res[1]["numCoopDefect"]],
  //         [res[2]["provinceName"], res[2]["numCoopDefect"]],
  //         [res[3]["provinceName"], res[3]["numCoopDefect"]],
  //         [res[4]["provinceName"], res[4]["numCoopDefect"]],
  //         [res[5]["provinceName"], res[5]["numCoopDefect"]],
  //         [res[6]["provinceName"], res[6]["numCoopDefect"]],
  //         [res[7]["provinceName"], res[7]["numCoopDefect"]],
  //         [res[8]["provinceName"], res[8]["numCoopDefect"]],
  //         [res[9]["provinceName"], res[9]["numCoopDefect"]],
  //         [res[10]["provinceName"], res[10]["numCoopDefect"]],
  //         [res[11]["provinceName"], res[11]["numCoopDefect"]],
  //         [res[12]["provinceName"], res[12]["numCoopDefect"]],
  //         [res[13]["provinceName"], res[13]["numCoopDefect"]],
  //         [res[14]["provinceName"], res[14]["numCoopDefect"]],
  //         [res[15]["provinceName"], res[15]["numCoopDefect"]],
  //         [res[16]["provinceName"], res[16]["numCoopDefect"]],
  //         [res[17]["provinceName"], res[17]["numCoopDefect"]],
  //         [res[18]["provinceName"], res[18]["numCoopDefect"]],
  //         [res[19]["provinceName"], res[19]["numCoopDefect"]],
  //         [res[20]["provinceName"], res[20]["numCoopDefect"]],
  //         [res[21]["provinceName"], res[21]["numCoopDefect"]],
  //         [res[22]["provinceName"], res[22]["numCoopDefect"]],
  //         [res[23]["provinceName"], res[23]["numCoopDefect"]],
  //         [res[24]["provinceName"], res[24]["numCoopDefect"]],
  //         [res[25]["provinceName"], res[25]["numCoopDefect"]],
  //         [res[26]["provinceName"], res[26]["numCoopDefect"]],
  //         [res[27]["provinceName"], res[27]["numCoopDefect"]],
  //         [res[28]["provinceName"], res[28]["numCoopDefect"]],
  //         [res[29]["provinceName"], res[29]["numCoopDefect"]],
  //         [res[30]["provinceName"], res[30]["numCoopDefect"]],
  //         [res[31]["provinceName"], res[31]["numCoopDefect"]],
  //         [res[32]["provinceName"], res[32]["numCoopDefect"]],
  //         [res[33]["provinceName"], res[33]["numCoopDefect"]],
  //         [res[34]["provinceName"], res[34]["numCoopDefect"]],
  //         [res[35]["provinceName"], res[35]["numCoopDefect"]],
  //         [res[36]["provinceName"], res[36]["numCoopDefect"]],
  //         [res[37]["provinceName"], res[37]["numCoopDefect"]],
  //         [res[38]["provinceName"], res[38]["numCoopDefect"]],
  //         [res[39]["provinceName"], res[39]["numCoopDefect"]],
  //         [res[40]["provinceName"], res[40]["numCoopDefect"]],
  //         [res[41]["provinceName"], res[41]["numCoopDefect"]],
  //         [res[42]["provinceName"], res[42]["numCoopDefect"]],
  //         [res[43]["provinceName"], res[43]["numCoopDefect"]],
  //         [res[44]["provinceName"], res[44]["numCoopDefect"]],
  //         [res[45]["provinceName"], res[45]["numCoopDefect"]],
  //         [res[46]["provinceName"], res[46]["numCoopDefect"]],
  //         [res[47]["provinceName"], res[47]["numCoopDefect"]],
  //         [res[48]["provinceName"], res[48]["numCoopDefect"]],
  //         [res[49]["provinceName"], res[49]["numCoopDefect"]],
  //         [res[50]["provinceName"], res[50]["numCoopDefect"]],
  //         [res[51]["provinceName"], res[51]["numCoopDefect"]],
  //         [res[52]["provinceName"], res[52]["numCoopDefect"]],
  //         [res[53]["provinceName"], res[53]["numCoopDefect"]],
  //         [res[54]["provinceName"], res[54]["numCoopDefect"]],
  //         [res[55]["provinceName"], res[55]["numCoopDefect"]],
  //         [res[56]["provinceName"], res[56]["numCoopDefect"]],
  //         [res[57]["provinceName"], res[57]["numCoopDefect"]],
  //         [res[58]["provinceName"], res[58]["numCoopDefect"]],
  //         [res[59]["provinceName"], res[59]["numCoopDefect"]],
  //         [res[60]["provinceName"], res[60]["numCoopDefect"]],
  //         [res[61]["provinceName"], res[61]["numCoopDefect"]],
  //         [res[62]["provinceName"], res[62]["numCoopDefect"]],
  //         [res[63]["provinceName"], res[63]["numCoopDefect"]],
  //         [res[64]["provinceName"], res[64]["numCoopDefect"]],
  //         [res[65]["provinceName"], res[65]["numCoopDefect"]],
  //         [res[66]["provinceName"], res[66]["numCoopDefect"]],
  //         [res[67]["provinceName"], res[67]["numCoopDefect"]],
  //         [res[68]["provinceName"], res[68]["numCoopDefect"]],
  //         [res[69]["provinceName"], res[69]["numCoopDefect"]],
  //         [res[70]["provinceName"], res[70]["numCoopDefect"]],
  //         [res[71]["provinceName"], res[71]["numCoopDefect"]],
  //         [res[72]["provinceName"], res[72]["numCoopDefect"]],
  //         [res[73]["provinceName"], res[73]["numCoopDefect"]],
  //         [res[74]["provinceName"], res[74]["numCoopDefect"]],
  //         [res[75]["provinceName"], res[75]["numCoopDefect"]],
  //         [res[76]["provinceName"], res[76]["numCoopDefect"]]

  //       ]);
  //     }

  //     await this.timeout(1200);

  //     const options = {
  //       region: 'TH',
  //       resolution: 'provinces',
  //       chartArea: { width: "100%", height: "100%" },
  //       colorAxis: {
  //         colors: ['#F2FBF8', '#3BC795', '#1F6D51', '#12402F', '#03254C'],
  //       }
  //     };
  //     var view = new google.visualization.DataView(this.shortComingsCoop_Chart);
  //     view.setColumns([0, 1]);


  //     const chart = new google.visualization.GeoChart(document.getElementById('Coop_Shortcomings'));
  //     google.visualization.events.addListener(chart, 'select', function () {
  //       var selectionIdx = chart.getSelection()[0].row;
  //       var countryName = view.getValue(selectionIdx, 0);
  //       // window.open('http://localhost:4200/Coop-info/' + countryName);
  //       window.open('https://bigdata.cpd.go.th/Coop-info/' + countryName);
  //       // window.open('http://172.17.2.103:888/Coop-info/' + countryName);
  //       // window.open('http://61.19.210.103:888/Coop-info/' + countryName);
  //       // window.open('http://122.155.201.148/Coop-info/' + countryName); //cat

  //     });
  //     chart.draw(view, options);
  //     this.SpinnerService.hide();
  //   });

  // }

  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }


  map1() {
    google.charts.load('current',
      { 'packages': ['geochart'] },
      { 'mapsApiKey': 'AIzaSyAOLYM76-S8-pL-_OUrZAax2cQAtJjEQCg' });
    google.charts.setOnLoadCallback(this.geochart);
  }

  map2() {
    google.charts.load('current',
      { 'packages': ['geochart'] },
      { 'mapsApiKey': 'AIzaSyAOLYM76-S8-pL-_OUrZAax2cQAtJjEQCg' });
    google.charts.setOnLoadCallback(this.MemberGeo_Coop);
  }

  map3() {
    google.charts.load('current',
      { 'packages': ['geochart'] }, //เลือกรูปแบบแผนที่
      { 'mapsApiKey': 'AIzaSyAOLYM76-S8-pL-_OUrZAax2cQAtJjEQCg' });
    google.charts.setOnLoadCallback(this.geochart_ฺbusiness_Coop);
  }

  map4() {
    // google.charts.load('current',
    //   { 'packages': ['geochart'] }, //เลือกรูปแบบแผนที่
    //   { 'mapsApiKey': 'AIzaSyAOLYM76-S8-pL-_OUrZAax2cQAtJjEQCg' });
    // google.charts.setOnLoadCallback(this.geochart_shortComings_Coop);
  }

  ngAfterViewInit() {
    //โหลดแผนที่อันแรกอย่างเดียวก่อน
    google.charts.load('current',
      { 'packages': ['geochart'] },
      { 'mapsApiKey': 'AIzaSyAOLYM76-S8-pL-_OUrZAax2cQAtJjEQCg' });
    google.charts.setOnLoadCallback(this.geochart);

    //แผนที่โลก
    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_AN", am4charts.XYChart);
        let data = [];
        let year_now = this.year_now;

        chart.logo.disabled = true; //ลบโลโก้ของ am4charts

        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis()); //แนวแกน y แนวตั้ง
        categoryAxis.dataFields.category = "year"; // เลือกเอา ตัวแปร year มาเป็นแกน y
        categoryAxis.renderer.labels.template.disabled = true; // ปิดข้อความแกน แกน y
        categoryAxis.renderer.grid.template.opacity = 0;
        categoryAxis.fontSize = "11px" // ฟอนต์ข้อความ

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis()); //แนวแกน x แนวนอน
        valueAxis.min = 0; // เริ่มต้นที่ 0
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;
        valueAxis.fontSize = "11px"

        // Create series
        function createSeries(field, name, color) {
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueX = field;
          series.dataFields.categoryY = "year";
          series.stacked = true;
          series.name = name;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let columnTemplate = series.columns.template;
          columnTemplate.strokeWidth = 2;
          columnTemplate.strokeOpacity = 1;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.locationX = 0.5;
          labelBullet.label.text = "{valueX}";
          labelBullet.label.fill = am4core.color("#fff");

        }

        chart.legend = new am4charts.Legend();
        for (let i = 0; i < res.length; i++) {
          // Add data
          data.push(
            {
              "year": year_now,
              "active": res[i].active,
              "nonactive": res[i].nonActive
            }
          )
        }
        chart.data = data;
        chart.logo.disabled = true;
        createSeries("active", "Active", "#4f9f0c");
        createSeries("nonactive", "Non-active", "#aa1107");

      })
    })

    // มาตรฐานสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);
        this.StandardTypeSum_pass =0;
        this.StandardTypeSum_notPass =0;

        for (let i = 0; i < res.length; i++) {

          this.StandardTypeSum_pass += res[i].pass;
          this.StandardTypeSum_notPass += res[i].notPass;

          if (res[i].coopType == "1") {
            this.StandardType_pass_level1 = res[i].pass;
            this.StandardType_notPass_level1 = res[i].notPass;
          }
          else if (res[i].coopType == "2") {
            this.StandardType_pass_level2 = res[i].pass;
            this.StandardType_notPass_level2 = res[i].notPass;
          }
          else if (res[i].coopType == "3") {
            this.StandardType_pass_level3 = res[i].pass;
            this.StandardType_notPass_level3 = res[i].notPass;
          }
          else if (res[i].coopType == "4") {
            this.StandardType_pass_level4 = res[i].pass;
            this.StandardType_notPass_level4 = res[i].notPass;
          }
          else if (res[i].coopType == "5") {
            this.StandardType_pass_level5 = res[i].pass;
            this.StandardType_notPass_level5 = res[i].notPass;
          }
          else if (res[i].coopType == "6") {
            this.StandardType_pass_level6 = res[i].pass;
            this.StandardType_notPass_level6 = res[i].notPass;
          }
          // else if (res[i].coopType == "7") {
          //   this.StandardType_pass_level7 = res[i].pass;
          //   this.StandardType_notPass_level7 = res[i].notPass;
          // }
        }

        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_Standard", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0;

        let data = [];
        let sum_standard_pass_
        let sum_standard_not_

        sum_standard_pass_ = this.StandardTypeSum_pass;
        sum_standard_not_ = this.StandardTypeSum_notPass;

        data.push(
          {
            "country": "ผ่านมาตรฐาน",
            "value": sum_standard_pass_,
            "color": am4core.color("#44c70d")
          },
          {
            "country": "ไม่ผ่านมาตรฐาน",
            "value": sum_standard_not_,
            "color": am4core.color("#ca0000")
          }
        )

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "มาตรฐานกลุ่มเกษตรกร";
        title.disabled = false;

        chart.data = data;
        chart.logo.disabled = true;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "มาตรฐานกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        let series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        // series.dataFields.radiusValue = "value";
        series.dataFields.category = "country";
        series.slices.template.cornerRadius = 6;
        series.colors.step = 2;
        series.slices.template.propertyFields.fill = "color";
        series.hiddenState.properties.endAngle = -90;

        // เพิ่มตัวเลขในวงกลม
        series.alignLabels = false;
        series.ticks.template.disabled = true;
        series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
        series.labels.template.radius = am4core.percent(-90);
        series.labels.template.fill = am4core.color("black");
        series.labels.template.relativeRotation = 90;

        // เปลี่ยนเปอร์เซ็นต์เป็นตัวเลข
        series.calculatePercent = true;
        series.labels.template.text = "{category}: {value.value}";
        series.slices.template.tooltipText = "{category}: {value.value}";

        chart.legend = new am4charts.Legend();
      })
    })

    // ระดับชั้นความเข้มแข็ง
    this.zone.runOutsideAngular(() => {
      // this.CoopServiceService.GetCoopLevelCount(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      //   am4core.useTheme(am4themes_dataviz);

      //   var chart = am4core.create("chartdiv_Strong", am4charts.PieChart);
      //   chart.hiddenState.properties.opacity = 0;
      //   let data = [];

      //   for (let i = 0; i < res.length; i++) {

      //     data.push(
      //       {
      //         "level": res[i].level,
      //         "value": res[i].count,
      //         // "color": am4core.color("#1F9B8C")
      //       }
      //     );
      //   }
      //   chart.data = data;
      //   chart.logo.disabled = true;

      //   chart.radius = am4core.percent(70);
      //   chart.innerRadius = am4core.percent(40);
      //   chart.startAngle = 180;
      //   chart.endAngle = 360;

      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "ระดับขั้นความเข้มแข็ง (หน่วย : สหกรณ์)";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "ระดับขั้นความเข้มแข็ง";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   var series = chart.series.push(new am4charts.PieSeries());
      //   series.dataFields.value = "value";
      //   series.dataFields.category = "level";
      //   series.slices.template.propertyFields.fill = "color";
      //   series.slices.template.propertyFields.stroke = "color";

      //   series.slices.template.cornerRadius = 10;
      //   series.slices.template.innerCornerRadius = 8;
      //   // series.slices.template.draggable = true;
      //   series.slices.template.inert = true;
      //   series.alignLabels = false;

      //   series.hiddenState.properties.startAngle = 90;
      //   series.hiddenState.properties.endAngle = 90;

      //   series.calculatePercent = true;
      //   series.labels.template.text = "{category}: {value.value}";
      //   series.slices.template.tooltipText = "{category}: {value.value}";

      //   chart.legend = new am4charts.Legend();

      // })
    })

    this.FamerServiceService.GetAgriFinanceNew(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สินทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_asset", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_asset) {

            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // หนี้สิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_debt", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].liabilities) {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ทุน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_Capital", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_capital) {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // กำไร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_profit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_profit) {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })

          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)ของกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)ของกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    // ปริมาณธุรกิจ
    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[0].year) {
            this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum1 = this.valSum1

            data.push({
              "year": res[i].year,
              "value": valSum1
            })
          }
          else if (res[1].year) {
            this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum2 = this.valSum2

            data.push({
              "year": res[i].year,
              "value": valSum2
            })
          }
          else if (res[2].year) {
            this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum3 = this.valSum3

            data.push({
              "year": res[i].year,
              "value": valSum3
            })
          }
          else if (res[3].year) {
            this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum4 = this.valSum4

            data.push({
              "year": res[i].year,
              "value": valSum4
            })
          }
          else if (res[4].year) {
            this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum5 = this.valSum5

            data.push({
              "year": res[i].year,
              "value": valSum5
            })
          }

        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ รวมทุกประเภทกลุ่มเกษตรกร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ รวมทุกประเภทกลุ่มเกษตรกร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px";
        valueAxis.title.text = "หน่วย : ล้านบาท";

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    this.FamerServiceService.GetAgriBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ เกษตร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type1", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '1') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2

              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3

              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type2", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '2') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2

              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3

              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type3", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '3') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2

              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3

              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type4", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '4') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2

              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3

              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type5", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '5') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2

              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3

              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type6", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '6') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1

              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2

              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3

              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5

              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : ล้านบาท"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ เครดิต
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);

      //   let chart = am4core.create("chartdiv_business_type7", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();
      //   chart.scrollbarY = new am4core.Scrollbar();
      //   let data = [];
      //   let valSum1
      //   let valSum2
      //   let valSum3
      //   let valSum4
      //   let valSum5

      //   for (let i = 0; i < res.length; i++) {

      //     if (res[i].coop_type == '7') {

      //       if (res[0].year) {
      //         this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
      //         valSum1 = this.valSum1

      //         data.push({
      //           "year": res[i].year,
      //           "value": valSum1
      //         })
      //       }
      //       else if (res[1].year) {
      //         this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
      //         valSum2 = this.valSum2

      //         data.push({
      //           "year": res[i].year,
      //           "value": valSum2
      //         })
      //       }
      //       else if (res[2].year) {
      //         this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
      //         valSum3 = this.valSum3

      //         data.push({
      //           "year": res[i].year,
      //           "value": valSum3
      //         })
      //       }
      //       else if (res[3].year) {
      //         this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
      //         valSum4 = this.valSum4

      //         data.push({
      //           "year": res[i].year,
      //           "value": valSum4
      //         })
      //       }
      //       else if (res[4].year) {
      //         this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
      //         valSum5 = this.valSum5

      //         data.push({
      //           "year": res[i].year,
      //           "value": valSum5
      //         })
      //       }

      //     }
      //   }

      //   chart.data = data;

      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์เครดิตยูเนี่ยน";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);

      //   // Create axes
      //   let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      //   categoryAxis.dataFields.category = "year";
      //   categoryAxis.renderer.grid.template.location = 0;
      //   categoryAxis.renderer.minGridDistance = 30;
      //   categoryAxis.renderer.labels.template.horizontalCenter = "right";
      //   categoryAxis.renderer.labels.template.verticalCenter = "middle";
      //   categoryAxis.renderer.labels.template.rotation = 270;
      //   categoryAxis.tooltip.disabled = true;

      //   categoryAxis.fontSize = "11px"
      //   //categoryAxis.title.text = "ปีชุดข้อมูล"

      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.renderer.minWidth = 50;
      //   valueAxis.fontSize = "11px"
      //   valueAxis.title.text = "หน่วย : ล้านบาท"

      //   // Create series
      //   let series = chart.series.push(new am4charts.ColumnSeries());
      //   series.sequencedInterpolation = true;
      //   series.dataFields.valueY = "value";
      //   series.dataFields.categoryX = "year";
      //   series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      //   series.columns.template.strokeWidth = 0;

      //   series.tooltip.pointerOrientation = "vertical";

      //   series.columns.template.column.cornerRadiusTopLeft = 10;
      //   series.columns.template.column.cornerRadiusTopRight = 10;
      //   series.columns.template.column.fillOpacity = 0.8;

      //   // on hover, make corner radiuses bigger
      //   let hoverState = series.columns.template.column.states.create("hover");
      //   hoverState.properties.cornerRadiusTopLeft = 0;
      //   hoverState.properties.cornerRadiusTopRight = 0;
      //   hoverState.properties.fillOpacity = 1;

      //   let bullet = series.bullets.push(new am4charts.LabelBullet())
      //   bullet.interactionsEnabled = false
      //   bullet.dy = -10;
      //   bullet.label.text = '{valueY}'
      //   bullet.label.fill = am4core.color('#000')

      //   series.columns.template.adapter.add("fill", function (fill, target) {
      //     return chart.colors.getIndex(target.dataItem.index);
      //   });

      //   chart.logo.disabled = true;
      //   // Cursor
      //   chart.cursor = new am4charts.XYCursor();
      // })

    });


    // การมีส่วนร่วมของสมาชิกสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop_sum", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        let sum_1 = 0
        let sum_2 = 0
        let sum_3 = 0
        let sum_4 = 0
        let sum_5 = 0

        for (let i = 1; i < res.length; i++) {

          data.push(
            {
              "year": res[i].year,
              "value": res[i].sum_member
            }
          )

        }


        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ทุกประเภท";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ทุกประเภท";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })
    })

    this.FamerServiceService.GetAgriProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ การเกษตร
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
            // res.splice(i, 1);
            // break;
          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำนา";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำนา";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_fishing", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำไร่";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำไร่";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_Settlement", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำสวน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำสวน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_saving", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_shop", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรเลี้ยงสัตว์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรเลี้ยงสัตว์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรอื่นๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรอื่นๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ เครดิต
      // this.zone.runOutsideAngular(() => {
      //   am4core.useTheme(am4themes_animated);
      //   let chart = am4core.create("chartdiv_Participation_credit", am4charts.XYChart);
      //   chart.scrollbarX = new am4core.Scrollbar();

      //   let data = [];

      //   for (let i = 0; i < res.length; i++) {
      //     if (res[i].coop_type == "7") {
      //       data.push({
      //         "year": res[i].year,
      //         "value": res[i].sum_member
      //       })
      //     }
      //   }

      //   chart.data = data;

      //   // Export
      //   let title = chart.titles.create();
      //   title.fontSize = "11px";
      //   title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทเครดิตยูเนี่ยน";
      //   title.disabled = false;
      //   chart.exporting.menu = new am4core.ExportMenu();
      //   chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทเครดิตยูเนี่ยน";
      //   chart.exporting.useWebFonts = false;
      //   chart.exporting.validateSprites.push(title);
      //   chart.exporting.validateSprites.push(title.parent);
      //   // Create axes
      //   let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      //   categoryAxis.dataFields.category = "year";
      //   categoryAxis.renderer.grid.template.location = 0;
      //   categoryAxis.renderer.minGridDistance = 30;
      //   categoryAxis.renderer.labels.template.horizontalCenter = "right";
      //   categoryAxis.renderer.labels.template.verticalCenter = "middle";
      //   categoryAxis.renderer.labels.template.rotation = 270;
      //   categoryAxis.tooltip.disabled = true;

      //   categoryAxis.fontSize = "11px"
      //   // categoryAxis.title.text = "ปีข้อมูล"

      //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.renderer.minWidth = 50;
      //   valueAxis.fontSize = "11px"
      //   valueAxis.title.text = "หน่วย : คน"

      //   // Create series
      //   let series = chart.series.push(new am4charts.ColumnSeries());
      //   series.sequencedInterpolation = true;
      //   series.dataFields.valueY = "value";
      //   series.dataFields.categoryX = "year";
      //   series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      //   series.columns.template.strokeWidth = 0;

      //   series.tooltip.pointerOrientation = "vertical";

      //   series.columns.template.column.cornerRadiusTopLeft = 10;
      //   series.columns.template.column.cornerRadiusTopRight = 10;
      //   series.columns.template.column.fillOpacity = 0.8;

      //   let bullet = series.bullets.push(new am4charts.LabelBullet())
      //   bullet.interactionsEnabled = false
      //   bullet.dy = -10;
      //   bullet.label.text = '{valueY}'
      //   bullet.label.fill = am4core.color('#000')

      //   // on hover, make corner radiuses bigger
      //   let hoverState = series.columns.template.column.states.create("hover");
      //   hoverState.properties.cornerRadiusTopLeft = 0;
      //   hoverState.properties.cornerRadiusTopRight = 0;
      //   hoverState.properties.fillOpacity = 1;

      //   series.columns.template.adapter.add("fill", function (fill, target) {
      //     return chart.colors.getIndex(target.dataItem.index);
      //   });

      //   chart.logo.disabled = true;
      //   // Cursor
      //   chart.cursor = new am4charts.XYCursor();

      // })
    })

  }

  ngOnDestroy() {
    // Clean up chart when the component is removed

    this.zone.runOutsideAngular(() => {

      am4core.disposeAllCharts();

    });
  }

  timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  coop_page() {
    this.router.navigate(['/']);
  }

  agri_page(url) {
    this.router.navigate(['/' + url]);
  }

}
